export function register() {
  if (!('serviceWorker' in navigator)) return;

  const onLoad = () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        reg.onupdatefound = () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.onstatechange = () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('[SW] New content available — reload to update.');
            }
          };
        };
      })
      .catch((err) => console.error('[SW] Registration failed:', err));
  };

  if (document.readyState === 'complete') {
    onLoad();
  } else {
    window.addEventListener('load', onLoad);
  }
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then((reg) => reg.unregister());
  }
}

export function getRegistration() {
  if ('serviceWorker' in navigator) {
    return navigator.serviceWorker.ready;
  }
  return Promise.reject(new Error('Service workers not supported'));
}
